<div class="notification">
    <ul>
        <li *ngFor="let notification of notifications" [ngClass]="{'success-msg': notification.type == 'success', 'error-msg': notification.type == 'error', 'info-msg': notification.type == 'info', 'warning-msg': notification.type == 'warning'}">
            <span class="loader" *ngIf="notification.isLoading"></span>
            <i *ngIf="!notification.isLoading" [ngClass]="{'icon icon-tick': notification.type == 'success', 'icon  icon-error': notification.type == 'error', 'icon  icon-info': notification.type == 'info', 'icon  icon-lnr-warning': notification.type == 'warning'}"></i>
            <a>{{notification.message}} </a>
        </li>
    </ul>
</div>


<!-- N O T I F I C A T I O N    
    L A T E S T D E S I G N -->
<!-- 
<div class="notification">
    <ul>
        <li class="success-msg">
        <i class="icon icon-tick"></i>
        <span>Node updated</span>
        </li>
        <li class="warning-msg">
        <i class="icon icon-xx"></i>
        <span>Node deleted</span>
        </li>
        <li class="success-msg">
        <i class="icon icon-tick"></i>
        <span>Node updated </span>
        </li>
        <li class="error-msg">
        <i class="icon icon-xx"></i>
        <span>Node deleted </span>
        </li>
    </ul>
</div> -->